import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { SideNav } from "../global/SideNav";
import { TopHeader } from "../global/TopHeader";
import { Main } from "../Main";
import { useIsMobile } from "../../hooks/useMediaQuery";
import OrganizationDropdown from "../global/OrganizationDropdown";
import OrganizationsTree from "../views/OrganizationTree";
import { closeOrganizationModal } from "../../js/actions";
import AppModal from "../global/AppModal";

function GlobalOrgModals() {
	const dispatch = useDispatch();
	const orgModal = useSelector((state) => state.orgModal.show);
	const hideModal = () => dispatch(closeOrganizationModal(""));
	return (
		<>
			<AppModal
				className="org-modal"
				show={orgModal === "change-org-modal"}
				onHide={hideModal}
				title="Change Account"
				body={<OrganizationDropdown closeModal={hideModal} />}
				maxWidth={440}
			/>
			<AppModal
				className="org-tree-modal"
				show={orgModal === "org-tree-modal"}
				onHide={hideModal}
				title="Accounts"
				body={<OrganizationsTree />}
				maxWidth={440}
			/>
		</>
	);
}

/** Page will render side navigation menu and react router component {Main.js} */
function Page({ onLogout }) {
	const user = useSelector((state) => state.authState.user);
	const permissions = useSelector((state) => state.authState.permissions);
	const mobileMode = useIsMobile();

	useEffect(() => {
		const email = user?.contact_info?.email ?? "";
		if (email) {
			SnapEngage?.setUserEmail(email);
		}
	}, [user]);

	return (
		<div className="page-container">
			<TopHeader user={user} onLogout={onLogout} permissions={permissions} />
			<SideNav onLogout={onLogout} />
			<Main permissions={permissions} mobileMode={mobileMode} />
			<GlobalOrgModals />
		</div>
	);
}

export default Page;
